export enum AuthoritiesEnum {
  ROLE_CLI_AUTH_IDENTIFIED = "ROLE_CLI-AUTH-IDENTIFIED",
  ROLE_CLI_1STPARTY = "ROLE_CLI-1STPARTY",
  ROLE_USER = "ROLE_USER",
  ROLE_AUTH_BASIC = "ROLE_AUTH-BASIC",
  ROLE_CLI_3RDPARTY = "ROLE_CLI-3RDPARTY",
  ROLE_AUTH_IDENTIFIED = "ROLE_AUTH-IDENTIFIED",
  ROLE_ADMIN = "ROLE_ADMIN",
  ROLE_PERSON = "ROLE_PERSON",
  ROLE_AUTH_MFA = "ROLE_AUTH-MFA",
  ROLE_DT_LOGONPORTALVC_ADMIN = "ROLE_DT_LOGONPORTALVC_ADMINMAINTENANCE",
  ROLE_DT_LOGONPORTALMANAGER_ADMINMAINTENANCE = "ROLE_DT_LOGONPORTALMANAGER_ADMINMAINTENANCE",
}
